module.exports = __webpack_public_path__ + "assets/img/zpimg1.d9186167.png";